export class Role {
  id? = "";

  role = "";
}

export class RoleForm extends Role {}

export class RoleRow extends Role {}
